import { CONTACT_LISTS_API_URL } from 'constants/ApiConstants';
import * as types from 'modules/contactMembers/actionTypes';

/**
 * @param {Partial<import('../types').FetchContactMembersQueryParams>} params
 * @param {Object} [meta={}]
 * @returns {import("../types").FetchContactMembersAction}
 */
export const fetchContactMembers = (contactListId, params, meta = {}) => ({
  type: types.FETCH_CONTACT_MEMBERS,
  payload: {
    request: {
      method: 'GET',
      url: `${CONTACT_LISTS_API_URL}/${contactListId}/members/filter`,
      params: {
        projection: 'paginated',
        ...params,
      }
    },
  },
  meta: {
    '@app-request': true,
    ...meta,
  },
});

/** @type {import("../types").OpenEditModalAction} */
export const openModalEdit = (contactMemberId, meta = {}) => ({
  type: types.OPEN_MODAL_EDIT,
  payload: contactMemberId,
  meta,
});

/** @return {import("../types").CloseEditModalAction} */
export const closeModalEdit = (meta = {}) => ({
  type: types.CLOSE_MODAL_EDIT,
  meta,
});

/** @return {import("../types").UpdateContactMemberAction} */
export const updateContactMember = (contactListId, contactMemberId, data, meta = {}) => ({
  type: types.UPDATE_CONTACT_MEMBER,
  payload: {
    contactListId,
    contactMemberId,
    request: {
      method: 'PUT',
      url: `${CONTACT_LISTS_API_URL}/${contactListId}/members/${contactMemberId}`,
      data
    },
  },
  meta,
});

/** @type {import("../types").UpdateContactMemberSuccessAction} */
export const updateContactMemberSuccess = (payload, meta = {}) => ({
  type: types.UPDATE_CONTACT_MEMBER_SUCCESS,
  payload,
  meta,
});

/** @type {import("../types").UpdateContactMemberFailureAction} */
export const updateContactMemberFailure = (error, meta = {}) => ({
  type: types.UPDATE_CONTACT_MEMBER_FAILURE,
  payload: error,
  error: true,
  meta,
});

/**
 * @param {string} contactListId - The ID of the contact list.
 * @param {string} contactMemberId - The ID of the member to delete.
 * @param {Object} [meta={}]
 * @returns {import("../types").DeleteContactMembersAction}
 */
export const deleteContactMembers = (contactListId, contactMemberId, meta = {}) => ({
  type: types.DELETE_CONTACT_MEMBERS,
  payload: {
    contactListId,
    contactMemberId,
    request: {
      method: 'DELETE',
      url: `${CONTACT_LISTS_API_URL}/${contactListId}/members/${contactMemberId}`,
    },
  },
  meta,
});

/**
 * @param {string} contactListId
 * @param {string} memberId
 * @param {Object} [meta={}]
 * @returns {import("../types").DeleteContactMembersSuccessAction}
 */
export const deleteContactMembersSuccess = (payload, meta = {}) => ({
  type: types.DELETE_CONTACT_MEMBERS_SUCCESS,
  payload,
  meta,
});

/**
 * @param {string} error
 * @param {Object} [meta={}]
 * @returns {import("../types").DeleteContactMembersFailureAction}
 */
export const deleteContactMembersFailure = (contactMemberId, error, meta = {}) => ({
  type: types.DELETE_CONTACT_MEMBERS_FAILURE,
  payload: { contactMemberId, error },
  error: true,
  meta,
});

/**
 * @param {string} field
 * @param {unknown} value
 * @param {Object} [meta={}]
 * @returns {import("../types").SetContactMembersFilterAction}
 */
export const setContactMembersFilter = (field, value, meta = {}) => ({
  type: types.SET_CONTACT_MEMBERS_FILTER,
  payload: { field, value },
  meta,
});
